module.exports = __webpack_public_path__ + "static/media/App.cb1e2760.less";


//////////////////
// WEBPACK FOOTER
// ./src/App.less
// module id = 656
// module chunks = 7